module.exports = __webpack_public_path__ + "img/youtube.47c0edd1.svg";